export default __webpack_public_path__ + "assets/images/bb2f6574470a56bffda69d9dc7fe729e.png";